export const inputEmployeeKeyword = {
    bindings: {
        identifier: '@',
        debounce: '@'
    },
    template: require('./input-employee-keyword.html'),
    controller: 'InputEmployeeKeywordController'
};
